export default class BooleanComparators {
    static is (subject, value) {
        return subject === value;
    }
}
